import { useState } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Solutions } from "@/components/Solutions";
import { Payroll } from "@/components/Payroll";
import { Calculator } from "@/components/Calculator";
import { StatementReview } from "@/components/StatementReview";
import { LeadForm } from "@/components/LeadForm";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/site";

export default function Landing() {
  const [prefill, setPrefill] = useState(null);
  const send = (p) => {
    setPrefill({ ...p, _t: Date.now() });
    scrollToId("quote");
  };
  return (
    <SmoothScroll>
      <div className="grain overflow-x-clip">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Solutions />
          <Payroll onSelect={() => send({ service: "Payroll" })} />
          <Calculator onLock={send} />
          <StatementReview onSelect={() => send({ statement_review: true })} />
          <LeadForm prefill={prefill} />
          <FAQ />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
